import Gamepad from "./gamepad.js";

export default () => {
  Gamepad();

  // Initialize focus on start item:
  if (document.pad) {
    document.pad.resetFocus();
  }
};
